// initial state
// shape: [{ id, quantity }]
const state = {
  userOptions: [],
  options: {
    status: [
      {label: '入账', value: 0},
      {label: '提现处理中', value: 1},
      {label: '财务处理中', value: 2},
      {label: '提现操作完成', value: 3},
      {label: '提现操作被驳回', value: 4},
      {label: '退回赏金', value: 5},
      {label: '购物消费', value: 80},
      {label: '消费退款', value: 81},
      {label: '交易冲正', value: 82},
      {label: '兑换', value: 99},
    ],
    withdrawtype: [
      {label: '银行卡', value: 0},
      {label: '支付宝', value: 1},
      {label: '批量提现（银行卡）', value: 2},
      {label: '批量提现（银行卡 全部）', value: 3},
      {label: '批量提现（支付宝）', value: 4},
      {label: '批量提现（支付宝 全部）', value: 5},
      {label: '微信', value: 6},
    ],
    withdraw_type: [
      {value: '-1', label: '未知'},
      {value: '0', label: '银行卡自主'},
      {value: '1', label: '支付宝自主'},
      {value: '2', label: '批量银行卡'},
      {value: '3', label: '批量银行卡全部'},
      {value: '4', label: '批量支付宝'},
      {value: '5', label: '批量支付宝全部'},
      {value: '6', label: '微信提现打款'},
    ],
  }
}

// getters
const getters = {
  // demoTable: state => state.table
}

const actions = {
  submitBatchWithdraw ({commit, state}, params) {
    let promised = request.alert('submitBatchWithdraw', params)
    return promised
  },

  batchWithdrawList ({commit, state}, params) {
    let promised = request.alert('batchWithdrawList', params)
    return promised
  },
  downBatchSourceFile ({commit, state}, params) {
    let promised = request.alert('downBatchSourceFile', params)
    return promised
  },
  batchWithdrawBatchList ({commit, state}, params) {
    let promised = request.alert('batchWithdrawBatchList', params)
    return promised
  },
  batchWithdrawBatchDetail ({commit, state}, params) {
    let promised = request.alert('batchWithdrawBatchDetail', params)
    return promised
  },
  batchWithdrawBatchConfirm ({commit, state}, params) {
    let promised = request.alert('batchWithdrawBatchConfirm', params)
    return promised
  },
  batchWithdrawBatchRollback ({commit, state}, params) {
    let promised = request.alert('batchWithdrawBatchRollback', params)
    return promised
  },
  batchWithdrawBatchSummary ({commit, state}, params) {
    let promised = request.alert('batchWithdrawBatchSummary', params)
    return promised
  },
}

// mutations
const mutations = {}

export const finance = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/finance/finance.store.js